import './ColumnOrder.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var dataTableV2ColumnDndOverlayCSS = '_1rt3gzg0-2-0-1';
export var insertPositionIndicatorCSS = _7a468({defaultClassName:'_1rt3gzg1-2-0-1',variantClassNames:{left:{true:'_1rt3gzg2-2-0-1',false:'_1rt3gzg3-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var verticalDividersCSS = '_1rt3gzg4-2-0-1';